<template>
  <div>
    <FormFilter
      :config="config"
      @filtered="displayResults"
      @has-results="displayPagination"
    />
    <div class="columns is-multiline">
      <div
        :key="index"
        v-for="(result, index) in displayedResults"
        class="column is-half-tablet is-one-third-desktop"
      >
        <DownloadListTeaser
          :result="result"
          :labels="labels"
          :key="`downloadlistteaser-${result.identifier}`"
        />
      </div>
    </div>
    <Pagination
      v-show="config.loadInitialData || hasResults"
      :config="config.pagination"
      :results="results.length"
      @update="displayPaginatedResults"
    />
  </div>
</template>

<script>
import FormFilter from "../FormFilter/FormFilter.vue";
import DownloadListTeaser from "../DownloadListTeaser/DownloadListTeaser.vue";
import Pagination from "../Pagination/Pagination.vue";

export default {
  name: "DownloadList",
  components: {
    FormFilter,
    DownloadListTeaser,
    Pagination
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      componentKey: 0,
      results: [],
      displayRange: [0, this.config.pagination.resultsPerPage - 1],
      displayedResults: [],
      labels: this.config.texts,
      hasResults: false
    };
  },
  methods: {
    displayPagination(hasResults) {
      this.hasResults = hasResults;
    },
    displayResults(results) {
      this.results = results;
      this.displayedResults = [];
      for (let i = 0; i < this.results.length; i++) {
        if (i >= this.displayRange[0] && i <= this.displayRange[1]) {
          this.displayedResults.push(this.results[i]);
        } else if (i > this.displayRange[1]) {
          break;
        }
      }
    },
    displayPaginatedResults(displayRange) {
      this.displayRange = displayRange;
      this.displayResults(this.results);
    }
  }
};
</script>
